import { render, staticRenderFns, recyclableRender, components } from "./u-radio.vue?vue&type=template&id=5dfbf8b1&scoped=true&"
var renderjs
import script from "./u-radio.vue?vue&type=script&lang=js&"
export * from "./u-radio.vue?vue&type=script&lang=js&"
import style0 from "./u-radio.vue?vue&type=style&index=0&id=5dfbf8b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!F:\\HBuilderX.3.8.12.20230817\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfbf8b1",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-radio/u-radio.vue"
export default component.exports